export default [

    /**
     * ------MODELS-------
     */
    {
        name: 'gltfScene',
        type: 'gltfModel',
        path: 'models/scene.gltf'
    },
    /**
     * ---------TEXTURES---------
     */
    // simple textures
    {
        name: 'rainTexture',
        type: 'texture',
        path: 'textures/static/rain.png'
    },
    // texture animations
    {
        name: 'waterAnim',
        type: 'texture',
        path: 'textures/animated/waterAnim.png'
    },
    {
        name: 'rainAnim',
        type: 'texture',
        path: 'textures/animated/rainAnim.png'
    },
    {
        name: 'staticAnim',
        type: 'texture',
        path: 'textures/animated/static.png'
    },
    {
        name: 'rippleAnim',
        type: 'texture',
        path: 'textures/animated/ripple.png'
    },
    /**
     * ---------AUDIO-----------
     */
    {
        name: 'footstep1',
        type: 'audio',
        path: 'audio/footstep1.mp3'
    },
    {
        name: 'footstep2',
        type: 'audio',
        path: 'audio/footstep2.mp3'
    },
    {
        name: 'footstep3',
        type: 'audio',
        path: 'audio/footstep3.mp3'
    },
    {
        name: 'footstep4',
        type: 'audio',
        path: 'audio/footstep4.mp3'
    },
    {
        name: 'windowRain',
        type: 'audio',
        path: 'audio/windowRain.mp3'
    },
    {
        name: 'rain',
        type: 'audio',
        path: 'audio/rain.mp3'
    },
    {
        name: 'doorOpen',
        type: 'audio',
        path: 'audio/doorOpen.mp3'
    },
    {
        name: 'doorClose',
        type: 'audio',
        path: 'audio/doorClose.mp3'
    },
    {
        name: 'water',
        type: 'audio',
        path: 'audio/water.mp3'
    },
    {
        name: 'wind',
        type: 'audio',
        path: 'audio/wind.mp3'
    },
    {
        name: 'bootUp',
        type: 'audio',
        path: 'audio/bootUp.mp3'
    },
    {
        name: 'wood',
        type: 'audio',
        path: 'audio/wood.mp3'
    },
    {
        name: 'clock',
        type: 'audio',
        path: 'audio/clock.mp3'
    },
    {
        name: 'drip',
        type: 'audio',
        path: 'audio/drip.mp3'
    },
    {
        name: 'static',
        type: 'audio',
        path: 'audio/static.mp3'
    },
    /**
     * ---------HDR-----------
     */
    {
        name: 'studioHDR',
        type: 'HDR',
        path: 'textures/static/studio.hdr'
    },
]